import request from "@/utils/request";

// sendbird user token 가져오기
export function fetchGetSendbirdToken() {
  return request({
    url: `/chat/api/v1/auth/user/token`,
    method: "get"
  });
}
